import * as React from 'react';
import ActionsManager from '../ActionsManager';
import {OBJECT_TYPES_NAMES, BaseActionsProps} from '../ActionsManagerConsts';

const GeneralActions: React.FunctionComponent<BaseActionsProps> = React.forwardRef((props, ref) => {
  return <ActionsManager noObjects objectType={OBJECT_TYPES_NAMES.GENERAL} ref={ref} {...props} />;
});

export default GeneralActions;
